import { apiFetch } from './client';
import type { PlaybookEntry } from '$lib/types';

export interface PlaybookEntryBody {
  section?: string;
  title?: string;
  body?: string;
  position?: number;
}

// playbookApi backs the Continuity module's admin-only Playbook — every
// route is admin-only server-side (see internal/api/handlers/playbook.go);
// HR must never reach it.
export const playbookApi = {
  list: () => apiFetch<PlaybookEntry[]>('/admin/continuity/playbook'),
  create: (body: PlaybookEntryBody) =>
    apiFetch<PlaybookEntry>('/admin/continuity/playbook', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: PlaybookEntryBody) =>
    apiFetch<PlaybookEntry>(`/admin/continuity/playbook/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  remove: (id: number) => apiFetch<{ detail: string }>(`/admin/continuity/playbook/${id}`, { method: 'DELETE' })
};
